import styled from "styled-components";

const Wrapper = styled.div`
  margin: 4rem 0rem;
  @media (max-width: 500px) {
    margin: 2rem 0;
  }
`;
export default Wrapper;
